import type { useWorkflowRuns } from '../hooks/useWorkflowRuns';

export type WorkflowRunsState = ReturnType<typeof useWorkflowRuns>;

/**
 * What the investigation screen offers on its workflow runs, by the workflows switch.
 *
 * Off stops anything new: no start, no gate answer, no branch, no retry. A run already under way
 * stays listed, readable and abandonable (FS-UC-02 3a); the server allows reading and abandoning
 * a run with the switch off. The runs view shows while the switch is on, or while there is a run.
 */
export function workflowSurfaces(
  workflowsEnabled: boolean,
  runs: WorkflowRunsState,
  onRunWorkflow: (workflowName: string) => void,
) {
  const on = workflowsEnabled;
  return {
    showRuns: on || runs.runs.length > 0,
    panel: {
      onRunWorkflow: on ? onRunWorkflow : undefined,
      onResolveGate: on ? runs.resolveGate : undefined,
      onTakeBranch: on ? runs.takeBranch : undefined,
      onRetryStep: on ? runs.retryStep : undefined,
      onAbandonRun: runs.abandonRun,
    },
    modal: {
      onResolveGate: on ? runs.resolveGate : undefined,
      onRetryStep: on ? runs.retryStep : undefined,
      onAbandonRun: runs.abandonRun,
    },
  };
}
